<template>
  <div class="radio-input-wrap">
    <div>
      <input
        type="radio"
        :id="id1"
        :value="value1"
        :disabled="disabled || disabledYes"
        :checked="value === value1"
        @change="select($event.target.value)"
      />
      <label :for="id1">{{ label1 }}</label>
    </div>
    <div>
      <input
        type="radio"
        :id="id2"
        :disabled="disabled"
        :value="value2"
        :checked="value === value2"
        @change="select($event.target.value)"
      />
      <label :for="id2">{{ label2 }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: "RoeRadioInput",
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: {
      required: true
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    disabledYes: {
      type: Boolean,
      default: () => false
    },
    label1: {
      type: String,
      default: () => "Yes"
    },
    value1: {
      default: () => 1
    },
    label2: {
      type: String,
      default: () => "No"
    },
    value2: {
      default: () => 0
    }
  },
  computed: {
    id1() {
      return this._uid;
    },
    id2() {
      return this._uid + 1;
    }
  },
  methods: {
    select(value) {
      this.$emit("change", Number.isNaN(+value) ? value : +value);
    }
  }
};
</script>
